import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as auth0 from 'auth0-js';

import { Auth0Client } from '../../../../../coverpath-common/angular/services/authentication/auth0.service';
import { WindowService } from '../../../../../common/angular-shared/services/window/window.service';
import { AMCAuth0Service } from '../../../../../coverpath-common/angular/services/authentication/amc/amc-auth0.service';

@Injectable()
export class CoverpathAuth0Service extends AMCAuth0Service {
  public constructor(
    protected windowService: WindowService,
    protected route: ActivatedRoute,
    protected router: Router
  ) {
    super(windowService, route, router);
  }

  protected getAuth0SignUpClient(): Auth0Client {
    return new auth0.WebAuth(this.getWebAuthConfig(true));
  }

  protected getAuth0Callback(isSignUp: boolean): string {
    const endpoint = `/auth0callback/${isSignUp ? 'signup' : 'login'}`;
    return this.windowService.nativeWindow.location.origin + endpoint;
  }
}
